import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleMobileMenuClose = () => {
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleHomeClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="relative">
      {/* Desktop Logo - Hidden on mobile */}
      <div className="fixed z-40 top-4 left-4 hidden lg:block">
        <Link to="/" aria-label="Home" onClick={handleHomeClick}>
          <img 
            src="/medinov.png" 
            alt="Media Nov Logo" 
            className="h-14 w-auto"
          />
        </Link>
      </div>

      {/* Desktop Navigation - Hidden on mobile */}
      <nav className="fixed z-40 top-8 flex h-16 w-full hidden lg:flex">
        <div className="relative flex items-center justify-between m-auto bg-white rounded-full py-1.5 px-6 max-w-3xl">
          <ul className={`nav-links lg:flex items-center justify-between grow basis-0 gap-3 ml-0 ${
            isMobileMenuOpen ? 'block' : 'hidden lg:flex'
          }`}>
            <li>
              <Link 
                to="/" 
                className="text-neutral-800 hover:text-neutral-600 transition-all duration-300 px-4 py-2 rounded-full hover:bg-gray-100 hover:scale-105 active:scale-95 inline-block"
                onClick={handleHomeClick}
              >
                Home
              </Link>
            </li>
            <li className="dropdown relative group">
              <Link 
                to="/services" 
                className="text-neutral-800 hover:text-neutral-600 transition-all duration-300 px-4 py-2 rounded-full hover:bg-gray-100 hover:scale-105 active:scale-95 inline-flex items-center" 
                aria-haspopup="true" 
                aria-expanded="false"
                onClick={handleMobileMenuClose}
              >
                Services
                <svg 
                  className="ml-1 h-4 w-4 transition-transform duration-300 group-hover:rotate-180" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth="2" 
                    d="M19 9l-7 7-7-7"
                  ></path>
                </svg>
              </Link>
              <ul className="dropdown-menu absolute z-10 bg-white rounded-3xl mt-2 py-3 px-2 w-44 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 ease-in-out">
                <li>
                  <a 
                    href="#digital-distribution" 
                    className="block px-3 py-2 text-sm text-neutral-800 hover:bg-gray-100 hover:scale-105 active:scale-95 transition-all duration-300 rounded-2xl text-center"
                  >
                    Digital Distribution
                  </a>
                </li>
                <li>
                  <Link 
                    to="/physical-distribution" 
                    className="block px-3 py-2 text-sm text-neutral-800 hover:bg-gray-100 hover:scale-105 active:scale-95 transition-all duration-300 rounded-2xl text-center"
                    onClick={handleMobileMenuClose}
                  >
                    Physical Distribution
                  </Link>
                </li>
                <li>
                  <a 
                    href="#rights-management" 
                    className="block px-3 py-2 text-sm text-neutral-800 hover:bg-gray-100 hover:scale-105 active:scale-95 transition-all duration-300 rounded-2xl text-center"
                  >
                    Rights Management
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <Link 
                to="/resources" 
                className="text-neutral-800 hover:text-neutral-600 transition-all duration-300 px-4 py-2 rounded-full hover:bg-gray-100 hover:scale-105 active:scale-95 inline-block"
                onClick={handleMobileMenuClose}
              >
                Resources
              </Link>
            </li>
            <li>
              <Link 
                to="/contact" 
                className="text-neutral-800 hover:text-neutral-600 transition-all duration-300 px-4 py-2 rounded-full hover:bg-gray-100 hover:scale-105 active:scale-95 inline-block"
                onClick={handleMobileMenuClose}
              >
                Contact
              </Link>
            </li>
          </ul>

          <button 
            id="mobile-menu-button" 
            className="lg:hidden cursor-pointer rounded-md border border-solid border-gray-300 ml-4 px-2 py-3"
            onClick={toggleMobileMenu}
          >
            <div className="mb-1 h-0.5 w-5 bg-neutral-400"></div>
            <div className="mb-1 h-0.5 w-5 bg-neutral-400"></div>
            <div className="h-0.5 w-5 bg-neutral-400"></div>
          </button>
        </div>
      </nav>

      {/* Mobile Header - Only visible on mobile */}
      <div className="lg:hidden fixed z-40 top-4 right-4">
        <div className="relative flex items-center justify-between m-auto rounded-full p-2 transition bg-white">
          <Link className="pl-4" to="/" aria-label="Home" onClick={handleHomeClick}>
            <img src="/medinov.png" width="40" alt="Media Nov Logo" className="h-10 w-auto" />
          </Link>
          
          <div className="hidden lg:flex px-12 gap-12">
            <Link className="text-neutral-800 hover:underline hover:text-neutral-600" to="/services">Services</Link>
            <Link className="text-neutral-800 hover:underline hover:text-neutral-600" to="/about">About</Link>
            <Link className="text-neutral-800 hover:underline hover:text-neutral-600" to="/contact">Contact</Link>
          </div>
          
          <div className="hidden grow basis-0 justify-end lg:flex">
            <Link className="flex items-center gap-2 rounded-full bg-black py-4 px-10 text-white hover:bg-white hover:text-black border-2 border-black transition-all" to="/contact">
              <span className="pt-px">Get Started Today</span>
            </Link>
          </div>
          
          <div 
            className="cursor-pointer sm:flex-col rounded-md border border-solid border-gray-300 ml-10 px-2 py-3 mr-5 lg:hidden"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <div className="mb-1 h-0.5 w-5 bg-neutral-400"></div>
            <div className="mb-1 h-0.5 w-5 bg-neutral-400"></div>
            <div className="h-0.5 w-5 bg-neutral-400"></div>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <>
          {/* Overlay */}
          <div 
            className="lg:hidden fixed inset-0 bg-black/50 z-[9998]"
            onClick={handleMobileMenuClose}
          ></div>
          
          {/* Menu */}
          <div className="lg:hidden fixed top-24 left-8 right-8 z-[9999] bg-white rounded-3xl mt-2 p-6 transition-all duration-300 ease-in-out max-w-md mx-auto shadow-2xl">
            <ul className="space-y-3">
            <li>
              <Link 
                to="/" 
                className="block text-neutral-800 hover:text-neutral-600 transition-all duration-300 py-3 px-6 rounded-full hover:bg-gray-100 hover:scale-105 active:scale-95 text-center font-medium"
                onClick={handleHomeClick}
              >
                Home
              </Link>
            </li>
            <li>
              <Link 
                to="/services" 
                className="block text-neutral-800 hover:text-neutral-600 transition-all duration-300 py-3 px-6 rounded-full hover:bg-gray-100 hover:scale-105 active:scale-95 text-center font-medium"
                onClick={handleMobileMenuClose}
              >
                Services
              </Link>
            </li>
            <li>
              <Link 
                to="/about" 
                className="block text-neutral-800 hover:text-neutral-600 transition-all duration-300 py-3 px-6 rounded-full hover:bg-gray-100 hover:scale-105 active:scale-95 text-center font-medium"
                onClick={handleMobileMenuClose}
              >
                About
              </Link>
            </li>
            <li>
              <Link 
                to="/resources" 
                className="block text-neutral-800 hover:text-neutral-600 transition-all duration-300 py-3 px-6 rounded-full hover:bg-gray-100 hover:scale-105 active:scale-95 text-center font-medium"
                onClick={handleMobileMenuClose}
              >
                Resources
              </Link>
            </li>
            <li>
              <Link 
                to="/contact" 
                className="block text-neutral-800 hover:text-neutral-600 transition-all duration-300 py-3 px-6 rounded-full hover:bg-gray-100 hover:scale-105 active:scale-95 text-center font-medium"
                onClick={handleMobileMenuClose}
              >
                Contact
              </Link>
            </li>
            <li className="pt-4 border-t border-gray-200">
              <Link 
                to="/contact" 
                className="block bg-black text-white text-center py-3 px-6 rounded-full hover:bg-gray-800 hover:scale-105 active:scale-95 transition-all duration-300"
                onClick={handleMobileMenuClose}
              >
                Get Started Today
              </Link>
            </li>
          </ul>
        </div>
        </>
      )}
    </header>
  );
};

export default Header;
